import { render, staticRenderFns } from "./BulletinsPage.vue?vue&type=template&id=52040baa&"
import script from "./BulletinsPage.vue?vue&type=script&lang=ts&"
export * from "./BulletinsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports